import React from 'react'

import {
  Box,
  Button,
  ButtonColorVariant,
  ButtonSize,
  Color,
  Display,
  FlexDirection,
  Link,
  LinkVariant,
  Space,
  Visible,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { CTAs, ENVIRONMENTAL_BENEFITS_BLOG_LINK } from '../../../config'
import { HomepageSections, trackCTAClick, TrackingActions } from '../../../tracking'

type CTABlockProps = {
  signupCTA: string
  onCTAClick: () => void
}

const FindOutMoreCTA = withCitrusTheme(Button, (theme) => ({
  background: theme.color(Color.Transparent),
}))

export const CTABlock = ({ signupCTA, onCTAClick }: CTABlockProps) => {
  const signupCTAClick = () => {
    onCTAClick()
    trackCTAClick(TrackingActions.CLICK_GET_STARTED, HomepageSections.ENVIRONMENTAL_BENEFITS)
  }

  const sustainabilityCTAClick = () => {
    trackCTAClick(TrackingActions.CLICK_FIND_OUT_MORE, HomepageSections.ENVIRONMENTAL_BENEFITS)
  }

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} width="100%">
      <Box width={['100%', null, '50%']}>
        <Link
          href={ENVIRONMENTAL_BENEFITS_BLOG_LINK}
          display={Display.Block}
          variant={LinkVariant.None}
          target="_blank"
        >
          <FindOutMoreCTA
            height="48px"
            width="100%"
            size={ButtonSize.Medium}
            colorVariant={ButtonColorVariant.Secondary}
            onClick={sustainabilityCTAClick}
          >
            {CTAs.sustainabilityCTA}
          </FindOutMoreCTA>
        </Link>
      </Box>
      <Space direction="horizontal" size={[0, 0, 4]} />
      <Box width={[null, null, '50%']}>
        <Visible display={[Display.None, Display.None, Display.Block]}>
          <Button onClick={signupCTAClick} width="100%" height="48px">
            {signupCTA}
          </Button>
        </Visible>
      </Box>
    </Box>
  )
}
